const skills =[
    {
        name: 'BACK-END'
    },
    {
        name: 'FRONT-END',
    },
    {
        name: 'JAVASCRIPT',
    },
    {
        name: 'PHP'
    },
    {
        name: 'PYTHON'
    },
    {
        name: 'REACT'
    },
    {
        name: 'RESEARCH'
    },
    {
        name: 'UX-UI'
    }
];

export default skills;